import { segmentStatus } from '@openx/types/segments.ts';
import { firstLetterUppercase } from '@openx/utils/lib/firstLetterUppercase.ts';

export function mapStatus(apiStatus?: string | null): {
  label: string;
  status: string;
} | null {
  if (apiStatus) {
    const label = apiStatus
      .split('_')
      .map(value => firstLetterUppercase(value))
      .join(' ');
    if (segmentStatus.READY === apiStatus) {
      return {
        label,
        status: 'active',
      };
    } else if (segmentStatus.ERROR === apiStatus) {
      return {
        label,
        status: 'error',
      };
    } else if (segmentStatus.EXPIRED === apiStatus) {
      return {
        label,
        status: 'warning',
      };
    } else {
      return {
        label,
        status: 'inactive',
      };
    }
  } else {
    return null;
  }
}
